import EditDoctorListDialog from '@pages/clinicPage/components/edit-doctor-list-dialog/edit-doctor-list-dialog';
import { useCallback, useState } from 'react';
import useToggle from '@app/hooks/useToggle';
import { DoctorListEditModalProps } from '@pages/clinicPage/model';
import { IFeedbackSite } from '@app/interfaces/feedback-site.interface';

export function useEditDoctorListDialog() {
  const [isOpen, doOpen, doClose] = useToggle();
  const [feedbackSite, setFeedbackSite] = useState<IFeedbackSite>();

  const openModal = useCallback(
    (site: IFeedbackSite) => {
      setFeedbackSite(site);
      doOpen();
    },
    [doOpen]
  );

  const modalProps = {
    isOpen,
    feedbackSite,
    onClose: doClose,
  } as DoctorListEditModalProps;

  return { modalProps, Modal: EditDoctorListDialog, openModal };
}
